import { NgOptimizedImage } from '@angular/common';
import { Component, inject, effect, computed, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CurrencyDropdownComponent } from 'src/app/core/currency-dropdown/currency-dropdown.component';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';
import { RippleDirective } from 'src/app/shared/directives/ripple/ripple.directive';

@Component({
  selector: 'app-header',
  imports: [
    NgOptimizedImage,
    CurrencyDropdownComponent,
    MatIconModule,
    RippleDirective,
    ComponentLoader,
    SideNavComponent
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  private readonly events = inject(EventsService);
  private readonly util = inject(UtilService);
  readonly vars = inject(VariablesService);

  readonly userData = computed(() => this.vars.userData());
  readonly profileSideState = computed(() => this.vars.sidebarDrawerState());
  readonly showLogin = signal(false);

  constructor() {
    effect(() => {
      const val = this.vars.sidebarDrawerState();
      if (this.vars.isBrowser()) {
        document.body.style.overflowY = val ? 'hidden' : '';
      }
    });
  }

  goToHome() {
    this.vars.sidebarDrawerState.set(false);
    if (this.vars.pageLayoutConfig()?.logoNavigate) {
      this.util.router.navigate(['/']);
    }
  }

  onProfileSidebarOpen() {
    this.vars.sidebarDrawerState.update(v => !v);
  }

  openLogin() {
    this.showLogin.set(true);
    this.events.sendSystemEvent({
      eventName: 'signin clicked',
      event_type: 'signin'
    });
  }

  closeLogin() {
    this.showLogin.set(false);
  }

  setCurrency(currency: string) {
    this.util.setCurrency(currency);
  }
}
